var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEarthAfricaBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12,0C5.383,0,0,5.383,0,12s5.383,12,12,12,12-5.383,12-12S18.617,0,12,0Zm0,22c-5.514,0-10-4.486-10-10,0-3.474,1.781-6.539,4.477-8.332l1.247,1.091c.175.153.276.375.276.608v.826c0,.446.362.808.808.808h.726c.305,0,.605-.083.867-.24l1.546-.928c.325-.195.742-.144,1.01.124l.801.801c.155.155.242.365.242.585v.831c0,.457-.37.827-.827.827h-2.633c-.352,0-.697.104-.99.3l-1.756,1.17c-.497.331-.795.888-.795,1.485v1.045c0,1.105.895,2,2,2h1.427c.337,0,.63.229.712.556l.693,2.774c.099.394.453.671.859.671h.807c.311,0,.599-.163.759-.43l2.495-4.159c.161-.269.247-.577.247-.891v-1.303c0-.459-.182-.9-.507-1.224l-.993-.993h2.257c.796,0,1.559-.316,2.121-.879l1.235-1.235c.569,1.255.886,2.648.886,4.114,0,5.514-4.486,10-10,10Z",
    fill: "rgba(100,21,255,1)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarthAfricaBold);
export default __webpack_public_path__ + "static/media/earth-africa-bold.36987c3d4d932579258f2eba633735ba.svg";
export { ForwardRef as ReactComponent };